<template>
    <div class="item-line-skin">
        <div class="item-line-skin__svg">
            <svg width="250" height="526" viewBox="0 0 200 526" fill="none">
                <image width="200" height="526" :xlink:href="imageNotClickBase64" />

                <g
                    v-for="(element, index) in getSprPhysResearch.arrayCircles"
                    :key="'A'+index"
                    class="circle"
                    @click="clickCircle(element, index)"
                    v-show="element.files.length > 0"
                    @mousemove="eventMousemove(element)"
                    @mouseleave="eventMouseleave(element)"
                >
                    <circle
                        v-for="(item, key) in element.array"
                        :key="'B'+key"
                        :cx="item.cx"
                        :cy="item.cy"
                        :r="calculateRadius(element, item, key, index)"
                        :fill="item.fill"
                    />
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import image from './imageBase64.json'

export default {
    data: () => ({
        imageNotClickBase64: image.imageNotClickBase64
    }),
    computed: {
        ...mapGetters({
            getSprPhysResearch: 'takeDiagnosticTest/getSprPhysResearch'
        })
    },
    methods: {
        ...mapMutations({
            changeSelectedCircle: 'takeDiagnosticTest/changeSelectedCircle',
            changeFlagMedia: 'takeDiagnosticTest/changeFlagMedia'
        }),
        calculateRadius(el, item, key, index) {
            if(el.hover) {
                if(key === 0) return item.r + 6
                else return item.r + 2
            }

            return item.r
        },
        eventMousemove(element) {
            if(element.hover) return;
            element.hover = true;
        },
        eventMouseleave(element) {
            element.hover = false;
        },
        clickCircle(element, index) {
            this.changeSelectedCircle({ element, index });
            this.changeFlagMedia(true);
        }
    }
}
</script>

<style lang="scss">
.item-line-skin {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;

    &__block {
        display: flex;
        justify-content: center;
        min-height: 60px;
        width: 100%;

        &__title {
            word-break: break-all;
        }
    }

    &__svg {
        display: flex;
        justify-content: center;
        width: 100%;
    }
}
.circle {
    cursor: pointer !important;
}
</style>